module.exports = __webpack_public_path__ + "static/media/53_B.1e52170c.png";